/**
 * Throwing stubs for the signer-management surface (approve/reject/remove
 * pending co-signers, invite/revoke Financial Controller co-signers,
 * simulate invited→pending transitions in the mocked table). The real hooks
 * ship in the signer-management epic (SDP-1694); until they do, every button
 * on the page fails loudly instead of faking success so integration/manual
 * testing surfaces the gaps rather than hiding them.
 *
 * Colocated with the sole consumer — `TeamMembers/index.tsx` — because these
 * are UI stubs, not data-layer hooks. When the real management hooks land,
 * delete this file and swap each destructured import at the callsite.
 */
export const SIGNER_MANAGEMENT_STUB_MESSAGE = "signer management hooks not wired yet";

const stub =
  (callsite: string) =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (..._args: unknown[]): never => {
    throw new Error(`${SIGNER_MANAGEMENT_STUB_MESSAGE} (${callsite})`);
  };

export const signerManagementStubs = {
  simulateInvitedToPending: stub("simulateInvitedToPending"),
  approvePendingSigner: stub("approvePendingSigner"),
  rejectPendingSigner: stub("rejectPendingSigner"),
  removeCoSigner: stub("removeCoSigner"),
  inviteCoSigner: stub("inviteCoSigner"),
  revokeCoSignerInvitation: stub("revokeCoSignerInvitation"),
} as const;
